// @flow
// $FlowFixMe
import React, { useContext } from "react";
import { find } from "lodash";
import { MobileFooter } from "@urp/mobile-footer";
import { isURP } from "@tvg/utils/generalUtils";
import mediator from "@tvg/mediator";
import { Containers } from "@fdr/static-ui/BaseComponents";
import Toast from "@fdr/atomic-ui/_atoms/Toast";
import { FeedbackMessageContext } from "@fdr/utils/contextUtils";
import { events as AlchemerEvents } from "@urp/alchemer";
import Routes from "../Routes";
import { Hashes } from "../Hashes";

const getFooterRoute = (key: string) => {
  const { path, name } = find(Routes, (r) => r.key === key) || {
    path: "",
    name: ""
  };
  return { href: path, name, key };
};

const getFooterHash = (key: string) => {
  const { hash, name } = find(Hashes, (r) => r.key === key) || {
    hash: "",
    name: ""
  };
  return { href: hash, name, key };
};

export const footerItems = [
  {
    ...getFooterRoute("home"),
    onClick: () => {
      mediator.base.dispatch({
        type: "FOOTER_CLICK_HOME",
        payload: { destinationUrl: getFooterRoute("home").href }
      });
      AlchemerEvents.homeTapped();
    }
  },
  {
    ...getFooterRoute("tracks"),
    onClick: () =>
      mediator.base.dispatch({
        type: "FOOTER_CLICK_TRACKS",
        payload: { destinationUrl: getFooterRoute("tracks").href }
      })
  },
  {
    ...getFooterHash("bets"),
    onClick: () => {
      mediator.base.dispatch({ type: "MYBETS_OPEN_FROM_FOOTER_FDR" });
    }
  },
  {
    ...getFooterHash("promos"),
    onClick: () => {
      mediator.base.dispatch({
        type: "FOOTER_CLICK_PROMOS",
        payload: { destinationUrl: getFooterHash("promos").href }
      });
    }
  },
  {
    ...getFooterRoute("account"),
    onClick: () => {
      mediator.base.dispatch({
        type: "FOOTER_CLICK_ACCOUNT",
        payload: {
          destinationUrl: getFooterRoute("account").href
        }
      });
    }
  }
];

const Footer = ({
  isVisible,
  isVisibleJoinBar,
  toastCallback
}: {
  isVisible: boolean,
  isVisibleJoinBar: boolean,
  toastCallback?: Function
}) => {
  const { toastProps } = useContext(FeedbackMessageContext);

  return (
    <React.Fragment>
      {isURP && !isVisible && (
        // Because toasts are inside the footer and the footer is hidden when PP betSlip is open
        // the toast message is being hidden also, this is to show the messages in PP when the footer is hidden
        <Containers.URPToastWrapper>
          {toastProps?.showToast && (
            <Toast
              {...toastProps}
              noAnimation={toastProps.isMessageShown}
              isTopPosition
              // $FlowFixMe
              callback={toastCallback}
            />
          )}
        </Containers.URPToastWrapper>
      )}

      {isVisible && (
        <Containers.URPToastWrapper isVisible={isVisible}>
          {toastProps?.showToast && (
            <Toast
              {...toastProps}
              noAnimation={toastProps.isMessageShown}
              isTopPosition
              // $FlowFixMe
              callback={toastCallback}
            />
          )}
        </Containers.URPToastWrapper>
      )}

      <MobileFooter
        isJoinBarVisible={isVisibleJoinBar}
        routes={footerItems}
        isVisible={isVisible}
      />
    </React.Fragment>
  );
};

export default Footer;
